import { ThemeContext } from '../../context/theme.context';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { getEvents } from '../../services/events/event';
import { getPlan } from '../../services/ControlCenter/PlanServices';
import TheTabComponent from './TheTabComponent';
import { memo, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeResetDataLoadingBoolenValue,
  setIsAppliedEventPlan,
  setIsPlanSelected,
} from '../../redux/search.slice';
import { FcCancel } from 'react-icons/fc';
import GlobalDialog from '../../components/GlobalDialog';
import { ButtonPropsModel } from '@syncfusion/ej2-react-popups';
import Message from '../../utils/Message/Message';
import { SyncFullOperations } from '../../services/MexServices/Orders/OrderService';
import { toast } from 'react-toastify';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';

interface IProps {}

let thePlanData: Array<any> = [];
const CloudPlanner: React.FC<IProps> = (props) => {
  let thePlanID = Number(localStorage.getItem('cs_plan_dd_value'));
  let theEventID = Number(localStorage.getItem('cs_event_dd_value'));
  let timezone_offset = useSelector(
    (state: any) => state.search.timezone_offset
  );
  const [eventsData, setEventsData] = useState<Array<any>>([]);
  const [planData, setPlanData] = useState<Array<any>>([]);

  const context = useContext(ThemeContext);
  const dispatch = useDispatch();
  const [ResetData, setResetData] = useState<boolean>(false);
  const [planValue, setPlanValue] = useState<number>(
    Number(localStorage.getItem('cs_plan_dd_value'))
  );
  const [isResetDataLoading, setisResetDataLoading] = useState<boolean>(false);
  const [resetDataToastinId, setresetDataToastinId]: any = useState(null);
  const [isDataResettingComponentHandle, setisDataResettingComponentHandle] =
    useState<boolean>(false);
  const reduxSearchS = useSelector((state: any) => state.search);
  const eventDropDownRef = useRef<DropDownListComponent | null>(null);
  const planDropDownRef = useRef<DropDownListComponent | null>(null);
  const mountedRef = useRef(true);
  useEffect(() => {
    mountedRef.current = true;

    const fetchData = async () => {
      await getEvent();
      if (theEventID !== 0 && thePlanID !== 0) {
        if (eventDropDownRef && eventDropDownRef !== null)
          eventDropDownRef.current &&
            (eventDropDownRef.current.value = theEventID);
        setPlanValue(thePlanID);
        onChangeEvents(false, {
          value: theEventID,
          plan_id: thePlanID,
          isTheSavedPlan: true,
        });
      } else {
        dispatch(
          setIsPlanSelected({
            isOrderPlanSelected: true,
            isOpPlanSelected: true,
            planId: 0,
          })
        );
      }
    };

    fetchData();
    return () => {
      mountedRef.current = false;
      context.setPlanId(0);
    };
  }, []);

  useEffect(() => {
    setisDataResettingComponentHandle(reduxSearchS.isResetDataLoading);
    if (isDataResettingComponentHandle) {
      toast.update(resetDataToastinId, {
        render: 'Data Successfully Resetted',
        type: 'success',
        autoClose: 4000,
        isLoading: false,
      });
    }
  }, [reduxSearchS.isResetDataLoading]);

  const getPlans = async (event_id: Number) => {
    await getPlan(event_id).then((res: any) => {
      const incomingData = Array.isArray(res?.data) ? res.data : [];

      incomingData.unshift({
        plan_name: '',
        ID: -1,
      });

      if (mountedRef.current) {
        thePlanData = incomingData;
        setPlanData(incomingData);
      }
    });
  };
  const getEvent = async () => {
    await getEvents().then((result) => {
      const incomingData = Array.isArray(result?.data) ? result.data : [];

      incomingData.unshift({
        eventCode: '',
        eventId: -1,
      });

      if (mountedRef.current) {
        setEventsData(incomingData);
      }
    });
  };

  let resetDataButton: ButtonPropsModel[] = [
    {
      buttonModel: { content: 'Yes' },
      click: () => {
        setResetData(false);
        resetDataFunction();
      },
    },
    {
      buttonModel: { content: 'No' },
      click: () => {
        setResetData(false);
      },
    },
  ];

  const resetDataFunction = () => {
    setisResetDataLoading(true);
    Message.success('Data is resetting...');
    dispatch(changeResetDataLoadingBoolenValue());
    setResetData(false);
    SyncFullOperations()
      .then((result) => {
        if (result.status == 200) {
          toast.update(resetDataToastinId, {
            render: 'All is good',
            type: 'success',
            isLoading: false,
          });
          setisResetDataLoading(false);
          Message.success('Synced successfully...');
          dispatch(changeResetDataLoadingBoolenValue());
        }
      })
      .catch((err) => {
        Message.error('Sync failed!!!');
      });
  };

  const onChangeEvents = async (isFirst: boolean, args: any) => {
    localStorage.setItem('cs_event_dd_value', args.value);
    const eventId = args.value;
    await getPlans(eventId);
    const plan_id = thePlanData.length > 0 ? thePlanData[1]?.ID : null;
    if (eventId === -1) {
      localStorage.removeItem('cs_event_dd_value');
      localStorage.removeItem('cs_plan_dd_value');
      context.setPlanId(0);
      dispatch(
        setIsPlanSelected({
          isOrderPlanSelected: true,
          isOpPlanSelected: true,
          planId: 0,
        })
      );
      if (isFirst) {
        context.setMaterialAllowChange(true);
        context.setResourcesAllowChange(true);
      }
      return;
    }
    if (thePlanData.length === 2 || args.isTheSavedPlan) {
      let thePlan = planData[1];
      if (args.isTheSavedPlan) {
        planDropDownRef.current &&
          (planDropDownRef.current.value = args.plan_id);
        await onChangePlan(isFirst, { value: args.plan_id });
        return;
      }
      if (plan_id !== null) {
        localStorage.setItem('cs_plan_dd_value', plan_id);
        planDropDownRef.current && (planDropDownRef.current.value = plan_id);
        setPlanValue(plan_id);
        context.setPlanId(plan_id);
        dispatch(
          setIsPlanSelected({
            isOrderPlanSelected: true,
            isOpPlanSelected: true,
            planId: plan_id,
          })
        );
        if (isFirst) {
          context.setResourcesAllowChange(true);
          context.setMaterialAllowChange(true);
        }
      }
    } else {
      context.setPlanId(0);
      dispatch(
        setIsPlanSelected({
          isOrderPlanSelected: true,
          isOpPlanSelected: true,
          planId: 0,
        })
      );
    }
  };
  const onChangePlan = async (isFirst: boolean, args: any) => {
    localStorage.setItem('cs_plan_dd_value', args.value);
    if (-1 === args.value) {
      localStorage.removeItem('cs_plan_dd_value');
      context.setPlanId(0);
      dispatch(
        setIsPlanSelected({
          isOrderPlanSelected: true,
          isOpPlanSelected: true,
          planId: 0,
        })
      );
      // if (isFirst) {
      //   context.setMaterialAllowChange(true);
      //   context.setResourcesAllowChange(true);
      // }
    } else {
      context.setPlanId(args.value);
      dispatch(
        setIsPlanSelected({
          isOrderPlanSelected: true,
          isOpPlanSelected: true,
          planId: args.value,
        })
      );
     // context.setPlanId(args.value);
      // if (isFirst) {
      //   context.setMaterialAllowChange(true);
      //   context.setResourcesAllowChange(true);
      // }
    }
  };

  return (
    <div>
      <div
        className='header-cloud-scheduler-fixed'
        style={{
          marginRight: 30,
          marginTop: 30,
        }}
      >
        {/*{ERP_TYPE == 'MEX' ? (*/}
        {/*  <FcCancel*/}
        {/*    title='Reload All Data'*/}
        {/*    size={30}*/}
        {/*    style={{ marginRight: 5 }}*/}
        {/*    onClick={() => {*/}
        {/*      if (isResetDataLoading || isDataResettingComponentHandle) {*/}
        {/*        Message.error('Data is resetting...');*/}
        {/*      } else {*/}
        {/*        setResetData(true);*/}
        {/*      }*/}
        {/*    }}*/}
        {/*  />*/}
        {/*) : (*/}
        {/*  <></>*/}
        {/*)}*/}

        {/* <AiOutlineFilter
            size={30}
            style={{ marginRight: 5 }}
            onClick={() => {
              sethideFilterDialog( true );
            }}
          /> */}
        {ResetData ? (
          <GlobalDialog
            showDialog={ResetData}
            setShowDialog={(val) => setResetData(val)}
            header='Reset data Message'
            width={'20%'}
            height={'20%'}
            hideDoneButton={true}
            content={'Are you sure to reset data ?'}
            buttons={resetDataButton}
          ></GlobalDialog>
        ) : null}
        <div className='cloud-scheduler-input'>
          <DropDownListComponent
            placeholder='Event'
            ref={eventDropDownRef}
            dataSource={eventsData}
            fields={{ text: 'eventCode', value: 'eventId' }}
            onChange={onChangeEvents.bind(this, true)}
            value={theEventID}
          />
        </div>
        <div className='cloud-scheduler-input'>
          <DropDownListComponent
            ref={planDropDownRef}
            placeholder='Plan'
            dataSource={planData}
            value={planValue}
            fields={{ text: 'plan_name', value: 'ID' }}
            onChange={onChangePlan.bind(this, true)}
          />
        </div>
        <ButtonComponent
          style={{ fontSize: '12px' }}
          onClick={() => {
            dispatch(setIsAppliedEventPlan({ isAppliedEventPlan: true }));
          }}
          content='Apply'
        />
      </div>
      <TheTabComponent />
    </div>
  );
};

export default memo(CloudPlanner);
